import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  image: string;
  tags: string[];
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: "新曲「夜空の向こう」制作秘話",
    excerpt: "最新シングル「夜空の向こう」の制作過程や込めた想いについてお話しします。この楽曲は私にとって特別な意味を持つ作品です。",
    content: "新曲「夜空の向こう」は、昨年の夏に体験した出来事がきっかけで生まれました。深夜のスタジオで一人ギターを弾いていた時、ふと窓の外に見えた星空に心を奪われ、そこから自然とメロディーが浮かんできたのです。この楽曲には、困難な時期を乗り越えた経験と、希望への想いを込めました。",
    date: "2024-01-15",
    category: "音楽制作",
    image: "https://readdy.ai/api/search-image?query=Singer%20songwriter%20in%20recording%20studio%20at%20night%20with%20guitar%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20professional%20music%20production%20setup%2C%20artistic%20and%20moody%20ambiance&width=800&height=400&seq=blog1&orientation=landscape",
    tags: ["新曲", "制作秘話", "夜空の向こう"]
  },
  {
    id: 2,
    title: "ライブツアー2024開催決定！",
    excerpt: "待望のライブツアー2024の開催が決定しました。全国10都市を回る予定で、新曲も含めた特別なセットリストをお届けします。",
    content: "皆様のおかげで、今年も全国ツアーを開催できることになりました。今回のツアーでは、新曲「夜空の向こう」をはじめ、ファンの皆様からリクエストの多かった楽曲も演奏予定です。各会場でしか聞けない特別なアレンジも用意していますので、ぜひお楽しみに！",
    date: "2024-01-10",
    category: "ライブ",
    image: "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20lighting%2C%20acoustic%20guitar%20setup%2C%20intimate%20live%20music%20venue%2C%20audience%20silhouettes%2C%20emotional%20performance%20atmosphere&width=800&height=400&seq=blog2&orientation=landscape",
    tags: ["ライブツアー", "2024", "全国ツアー"]
  },
  {
    id: 3,
    title: "音楽への想いと今後の活動について",
    excerpt: "音楽を始めたきっかけから現在まで、そして今後の活動についての想いを綴りました。ファンの皆様への感謝の気持ちも込めて。",
    content: "音楽を始めたのは高校生の時でした。友人に借りたギターで初めて弾いた時の感動は今でも忘れられません。それから10年以上が経ち、多くの方に支えられながら音楽活動を続けることができています。これからも心に響く楽曲を作り続け、皆様と音楽を通じて繋がっていきたいと思います。",
    date: "2024-01-05",
    category: "日記",
    image: "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20close%20up%20with%20sheet%20music%2C%20warm%20natural%20lighting%2C%20creative%20workspace%2C%20artistic%20composition%2C%20inspiring%20music%20creation%20scene&width=800&height=400&seq=blog3&orientation=landscape",
    tags: ["音楽", "想い", "感謝"]
  },
  {
    id: 4,
    title: "冬の楽曲制作日記",
    excerpt: "寒い季節にインスピレーションを受けて制作している新しい楽曲について。冬の情景を音楽で表現する試みについてお話しします。",
    content: "冬の静寂な雰囲気からインスピレーションを得て、新しい楽曲を制作中です。雪が降る夜の静けさや、暖かい部屋で過ごす時間の温もりを音楽で表現したいと思っています。アコースティックギターをメインに、シンプルながらも心に響くメロディーを目指しています。",
    date: "2023-12-28",
    category: "音楽制作",
    image: "https://readdy.ai/api/search-image?query=Winter%20music%20studio%20scene%20with%20acoustic%20guitar%2C%20cozy%20atmosphere%2C%20snow%20outside%20window%2C%20warm%20interior%20lighting%2C%20creative%20songwriting%20environment&width=800&height=400&seq=blog4&orientation=landscape",
    tags: ["冬", "楽曲制作", "アコースティック"]
  },
  {
    id: 5,
    title: "ファンの皆様からのメッセージに感謝",
    excerpt: "最近いただいたファンレターやメッセージについて。皆様からの温かい言葉が創作活動の大きな支えになっています。",
    content: "最近、たくさんのファンレターやSNSでのメッセージをいただき、本当に感謝しています。「あの曲に救われました」「ライブで元気をもらいました」といった言葉を読むたびに、音楽を続けていて良かったと心から思います。皆様の声が私の創作活動の原動力です。",
    date: "2023-12-20",
    category: "日記",
    image: "https://readdy.ai/api/search-image?query=Handwritten%20letters%20and%20messages%20on%20wooden%20desk%2C%20warm%20lighting%2C%20personal%20and%20intimate%20atmosphere%2C%20gratitude%20and%20connection%20theme&width=800&height=400&seq=blog5&orientation=landscape",
    tags: ["ファン", "感謝", "メッセージ"]
  },
  {
    id: 6,
    title: "年末ライブの思い出",
    excerpt: "先日開催した年末ライブの振り返り。特別な夜となったライブの様子や、印象に残ったエピソードをお話しします。",
    content: "年末ライブは本当に特別な夜となりました。会場に足を運んでくださった皆様、ありがとうございました。最後の「星に願いを」では、会場全体が一つになったような感覚があり、音楽の持つ力を改めて感じることができました。来年もより良いライブをお届けできるよう頑張ります。",
    date: "2023-12-15",
    category: "ライブ",
    image: "https://readdy.ai/api/search-image?query=Intimate%20acoustic%20concert%20venue%20with%20warm%20stage%20lighting%2C%20audience%20enjoying%20live%20music%2C%20emotional%20performance%20moment%2C%20cozy%20atmosphere&width=800&height=400&seq=blog6&orientation=landscape",
    tags: ["年末ライブ", "思い出", "星に願いを"]
  }
];

const categories = ["すべて", "音楽制作", "ライブ", "日記"];

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState("すべて");
  const [selectedPost, setSelectedPost] = useState<BlogPost | null>(null);

  const filteredPosts = selectedCategory === "すべて" 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (selectedPost) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <main className="pt-16">
          {/* Article Header */}
          <div className="bg-gray-50 py-12">
            <div className="container mx-auto px-6">
              <button
                onClick={() => setSelectedPost(null)}
                className="flex items-center text-gray-600 hover:text-black mb-6 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                ブログ一覧に戻る
              </button>
              <div className="max-w-4xl">
                <div className="flex items-center gap-4 mb-4">
                  <span className="bg-black text-white px-3 py-1 rounded-full text-sm">
                    {selectedPost.category}
                  </span>
                  <span className="text-gray-500 text-sm">
                    {formatDate(selectedPost.date)}
                  </span>
                </div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  {selectedPost.title}
                </h1>
                <div className="flex flex-wrap gap-2">
                  {selectedPost.tags.map((tag, index) => (
                    <span key={index} className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-sm">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Article Content */}
          <div className="container mx-auto px-6 py-12">
            <div className="max-w-4xl mx-auto">
              <img
                src={selectedPost.image}
                alt={selectedPost.title}
                className="w-full h-96 object-cover object-top rounded-lg mb-8"
              />
              <div className="prose prose-lg max-w-none">
                <p className="text-lg text-gray-700 leading-relaxed">
                  {selectedPost.content}
                </p>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-gray-50 py-20">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              ブログ
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              音楽制作の裏側や日々の想い、ライブの思い出など、アーティストとしての日常をお届けします。
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 border-b border-gray-200">
          <div className="container mx-auto px-6">
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-black text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="py-16">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article
                  key={post.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setSelectedPost(post)}
                >
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-sm">
                        {post.category}
                      </span>
                      <span className="text-gray-500 text-sm">
                        {formatDate(post.date)}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {post.tags.slice(0, 2).map((tag, index) => (
                        <span key={index} className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs">
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <div className="flex items-center text-black font-medium">
                      続きを読む
                      <i className="ri-arrow-right-line ml-2"></i>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}